import { left } from "@popperjs/core";
import { resource } from "../objects/resource";
import { DirectionalHint, ITooltipHostStyles, TooltipDelay, TooltipHost } from "@fluentui/react";
import { archivedSite } from "../objects/archivedSite";
import { getFormattedDate } from "../utils";

interface archivedCardProps {
  ownedResource: archivedSite;
}

/**
 *
 * @param props
 * @returns
 */
export function ArchivedCard(props: archivedCardProps) {
  const hostStyles: Partial<ITooltipHostStyles> = { root: { display: "inline-block" ,width:"100%"} };
  return (
    <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
      <div>
        <br />
        <div className="row">
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Site  URL:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <input
              style={{ display: "inline-block" }}
              type="text"
              className="form-control"
              value={props.ownedResource.siteUrl}
              disabled
            />
          </div>
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Name:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <input
              style={{ display: "inline-block" }}
              type="text"
              className="form-control"
              value={props.ownedResource.name ? props.ownedResource.name : "No name defined"}
              disabled
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Archived When:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <input
              style={{ display: "inline-block" }}
              type="text"
              className="form-control"
              value={new Date(props.ownedResource.lastUpdated).toLocaleDateString()}
              disabled
            />
          </div>
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Archived By:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <input
              style={{ display: "inline-block" }}
              type="text"
              className="form-control"
              value={props.ownedResource.archivedBy}
              disabled
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Workspace Type:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <input
              style={{ display: "inline-block" }}
              type="text"
              className="form-control"
              value={props.ownedResource.m365ResourceType}
              disabled
            />
          </div>
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Group ID:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <input
              style={{ display: "inline-block" }}
              type="text"
              className="form-control"
              value={props.ownedResource.m365GroupId ? props.ownedResource.m365GroupId  : "Not connected to M365 group"}
              disabled
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Required for Retention:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <textarea
              style={{ display: "inline-block" }}
              className="form-control"
              id="inputPassword"
              value={props.ownedResource.requiredForRetention ? props.ownedResource.requiredForRetention : "Not required for retention"}
              disabled
              rows={3}
            />
          </div>
          <div className="col-2 col-lg-1">
            <label
              style={{
                display: "inline-block",
                fontWeight: "bold",
                float: left,
                inlineSize: "100%",
                textAlign: "start",
                paddingLeft: "4%",
              }}
              className="col-sm-2 col-form-label"
            >
              Bussiness Justification:
            </label>
          </div>
          <div className="col-4 col-lg-5">
            <textarea
              style={{ display: "inline-block" }}
              className="form-control"
              id="inputPassword"
              value={props.ownedResource.businessJustification ? props.ownedResource.businessJustification : "No business justification was provided" }
              disabled
              rows={3}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArchivedCard;
